/* eslint-disable */
const errorMessages = {
  'auth/invalid-email': 'メールアドレスの形式が正しくありません。',
  'auth/user-not-found': 'この識別子に対応するユーザー レコードはありません。 ユーザーが削除された可能性があります。',
  'auth/wrong-password': 'パスワードが無効であるか、ユーザーがパスワードを持っていません。',
  'auth/email-already-in-use': 'メールアドレスはすでに別のアカウントで使用されています。',
  'auth/weak-password': 'パスワードは 6 文字以上にする必要があります。'
}

const getErrorMessage = (error) => {
  if (error && error.code) {
    return errorMessages[error.code] || error.message || 'エラーが発生しました。しばらくしてからもう一度お試しください。'
  }

  return null
}

export const alertError = (error) => {
  if (error && error.code === 'auth/popup-closed-by-user') {
    return
  }

  alert(getErrorMessage(error))
}